import { render } from "./NavBottom.vue?vue&type=template&id=682f7262&scoped=true"
import script from "./NavBottom.vue?vue&type=script&lang=js"
export * from "./NavBottom.vue?vue&type=script&lang=js"

import "./NavBottom.vue?vue&type=style&index=0&id=682f7262&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682f7262"]])

export default __exports__